"use strict";

window.FoG = window.FoG || {};

window.FoG.SignalVote = (function($) {
  var voting = false;
  
  function onVoteResponse(response) {
    var $scorer = $('.voteScorer[data-voteScorer=' + response.voteId + ']');
    $scorer.find('.voteScore').text(response.score);

    var $voteButtons = $scorer.find('.upvote, .downvote');
    $voteButtons.removeClass('active');

    if (response.vote > 0) {
      $voteButtons.filter('.upvote').addClass('active');
    }
    
    if (response.vote < 0) {
      $voteButtons.filter('.downvote').addClass('active');
    }
    
    voting = false;
  }
  
  function voteClicked(e) {
    e.preventDefault();
    if (voting) { return; }
    
    var $this = $(this);
    var $scorer = $this.closest('.voteScorer');
    var vote = $this.hasClass('active') ? 0 : ($this.hasClass('upvote') ? 1 : -1);
    var voteId = $scorer.attr('data-voteScorer');
    
    if (!voteId) {
      console.log("Could not find vote id for scorer.");
      return;
    }

    var params = {
      vote: vote,
      vote_id: voteId,
      _wpnonce: $scorer.find('input[name=_wpnonce]').val()
    }

    voting = true;
    var fnResetVoting = () => { voting = false; }
    NA.Ajax.post('signal-vote', params, onVoteResponse, fnResetVoting);
  }
  
  function init(signalContainerSelector) {
    $('.upvote,.downvote').on('click', voteClicked);
  }
  
  return {
    init:init
  };
})(jQuery);